import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors } from '~styles/theme.stylex';
const REDUCED = '@media (prefers-reduced-motion: reduce)';
const DESKTOP = '@media (min-width: 60rem)';

// Track holds two copies of its row, so -50% loops seamlessly.
const drift = "x1ofc7ps-B";
export const styles = {
  wall: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x15iy025",
    rowGap: null,
    columnGap: null,
    marginTop: "x1hpjnmm",
    marginInline: "x1cafle",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  },
  row: {
    overflowX: "x6ikm8r xqq5ypf",
    $$css: true
  },
  track: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    width: "xezivpi",
    animationName: "x1avuawy x1aquc0h",
    animationDuration: "x30pxwf",
    animationTimingFunction: "x1esw782",
    animationIterationCount: "xa4qsjk",
    animationPlayState: "xoj058f xg4gkpr",
    $$css: true
  },
  trackReverse: {
    animationDirection: "xeo85xg",
    animationDuration: "xjc5gw",
    $$css: true
  },
  rowSwipe: {
    overflowX: "xw2csxc",
    scrollbarWidth: "x1rohswg",
    $$css: true
  },
  trackStatic: {
    animationName: "x1a5igra",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  photo: {
    height: "xw1cyfh x1pmesj2",
    width: "x14atkfc",
    marginRight: "x1yjprzi",
    marginInlineStart: null,
    marginInlineEnd: null,
    borderRadius: "x1yt6v20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "x1a87jhh",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1w1xcey",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    boxShadow: "x1yqlisx",
    flexShrink: "x2lah0s",
    $$css: true
  },
  tiltA: {
    transform: "x4pakdm",
    $$css: true
  },
  tiltB: {
    transform: "x1d74iyf",
    $$css: true
  }
};